import {createContext, useState} from "react";

export const ForeignerOTPContext = createContext({})

export const Provider = (props) => {
    const {children} = props;

    const [sendOTP, setSendOTP] = useState(null);
    const [sendOTPs, setSendOTPs] = useState([]);
    const [sendOTPDialog, setSendOTPDialog] = useState(false);

    // Make the context object:
    const sendOTPContext = {
        sendOTP,
        setSendOTP,
        sendOTPs,
        setSendOTPs,
        sendOTPDialog,
        setSendOTPDialog,
    };

    // pass the value in provider and return
    return <ForeignerOTPContext.Provider value={sendOTPContext}>{children}</ForeignerOTPContext.Provider>;
}

export const {Consumer} = ForeignerOTPContext;
